<footer>
	<global-nav-footer-links class="global-nav"></global-nav-footer-links>
	<global-nav-family-bar class="outerSpace"></global-nav-family-bar>
	<global-nav-legal-bar class="outerSpace"></global-nav-legal-bar>
</footer>
